export default function fancybox() {
    if (document.querySelector(".page-perfil-gallery")) {
        Fancybox.bind("[data-fancybox='gallery']", {
            Thumbs: {
                type: "classic",
            },
        });
    }

    Fancybox.bind("[data-fancybox='gallery']", {
        Thumbs: {
            type: "classic",
        },
    });

    Fancybox.bind("[data-fancybox='video-about']", {
        Thumbs: {
            type: "classic",
        },
    }); 
}
